import React, { useEffect, useRef, useState } from 'react';
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, message } from 'antd';
import { CloudSyncOutlined, FileAddOutlined, InfoCircleOutlined, LinkOutlined, ImportOutlined } from '@ant-design/icons'
import AssetRepository from '../../components/adms/AssetRepository'
import NewElement from '../../components/editor/NewElement';
import Taxonomy from '../../components/skos/Taxonomy';
import Tags from '../../components/tags/Tags';
import Langs from '../../components/langs/Langs';
import Alphabet from '../../components/alphabet/Alphabet';
import Search from '../../components/search/Search';
import FilterData from '../../components/filter/FilterData';
import { RdfTriplet, AdmsRepository, AdmsAsset} from '../../redux';
import { subsetByLangOrEmpty, getCountValue } from '../../virtuoso/helper';
import CatalogData from '../../components/adms/CatalogData';
import ExportToDocument from '../../components/export/ExportToDocument';
import WebProtegeApi from '../../webprotege/ApiUtils';
import settings from '../../virtuoso/settings';
import { getValues } from '../../virtuoso/helper';
import { DetailLinkCard } from '../../components/adms/DetailLinkCard';
import SettingsMenu from '../../components/settings/SettingsMenu';
import { SelectUnLinkAssetForm } from '../../components/editor/SelectIndividual';
import ImportCard from '../../components/import/ImportCard';
//import { getProjectId}  from '../../webprotege/helper';

const { confirm } = Modal;

const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("AssetList.js showViewDetail", selected); 
	return <Modal style={{minWidth: "80%"}} open={true} 
    title={i18n.t('views.adms.detail_title')}
    cancelText={i18n.t('views.adms.detail_cancel')} onCancel={onCancelOperation} 
    cancelButtonProps={{ disabled: true, dispaly: "none" }}
    okText={i18n.t('views.adms.detail_ok')} onOk={onFinishOperation}>
        <DetailLinkCard triplet={selected} factory={factory}/>
	  </Modal>
}

/**
 *  Отображение формы добавление нового элемента в каталоге
 * 
 *  Модальная форма на основе примера см. https://stackblitz.com/edit/ant-modal-form?file=index.js
 */
const showAdd = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f) => {  
  return <Modal 
          style={{minWidth: 900}} open={true}  
          title={i18n.t('views.adms.add_title')}
          cancelText={i18n.t('views.adms.add_cancel')} onCancel={onCancelOperation}
          okText={i18n.t('views.adms.add_okf')} onOk={onFinishOperation}>	
        <NewElement formRef={formRef} rdfType={"http://www.w3.org/ns/dcat#Dataset"}/>
	  </Modal>
}

const showInfo = (formRef=f=>f, factory, onEditOperation=f=>f, onCloseOperation=f=>f, authorized=false, handlers=f=>f) => {
	//console.log("AssetList.js", "showInfo");
	return <Modal 
      style={{minWidth: 700}} open={true}  
      title={i18n.t('views.adms.catalog_title')}
      cancelText={i18n.t('views.adms.catalog_cancel')} onCancel={onCloseOperation} 
      okText={i18n.t('views.adms.catalog_ok')} onOk={onEditOperation}
      okButtonProps={{
        style: {
          cursor: !authorized ? 'not-allowed' : 'default',
        },
        disabled: !authorized,
      }}
      >	
        <CatalogData factory={factory} wrappedComponentRef={formRef} handlers={(e,t,o)=> handlers(e,t,o)} />
	  </Modal>
};

const showLinkAsset = (formRef=f=>f, factory, onSelectOperation=f=>f, onCloseOperation=f=>f, handlers=f=>f, 
  subject, selected=false) => {
	//console.log("AssetList.js", "showInfo");
	return <Modal 
      style={{minWidth: 700}} open={true}  
      title={i18n.t('views.adms.select_title')}
      cancelText={i18n.t('views.adms.select_cancel')} onCancel={onCloseOperation} 
      okText={i18n.t('views.adms.select_ok')}  onOk={onSelectOperation}
      okButtonProps={{
        style: {
          cursor: !selected ? 'not-allowed' : 'default',
        },
        disabled: !selected,
      }}
      >	
        <SelectUnLinkAssetForm factory={factory} formRef={formRef} 
          subject={subject} predicat="http://www.w3.org/ns/dcat#dataset"
          handlers={(e,t,o)=> handlers(e,t,o)} />
	  </Modal>
}


/** Добавить условие в список. Для словий с одной схемой формируется массив значений */
const includedConditions = (conditions, condition) => {
  //Проверим, что такая схема есть и тогда сделаем массив значений
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (!Array.isArray(scheme[0].value))
      scheme[0].value = [scheme[0].value];
    scheme[0].value.push(condition.value);
    return conditions;
  }
  return conditions.concat([condition])
}
/** Исключить условие из поиска */
const excludedConditions = (conditions, condition, taxonomy, lang) => {
  //console.log("AssetList.js excludedConditions", conditions, condition, taxonomy, lang);
  //Проверим, что такая схема есть и тогда исключим из массива значений значение condition
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (Array.isArray(scheme[0].value)){
        scheme[0].value = scheme[0].value.filter(item => item != condition.value)
        if (scheme[0].value.length == 1){
            scheme[0].value = scheme[0].value[0]
            //Надо обновить label, т.к. может он может не совпадать
            //label задаётся при добавлении условия, для массива label - первый заданный condition
            //см. отображение условий в FilterData.js
            const schemes = taxonomy.filter(item => item.IRI && item.IRI.value && (item.IRI.value == condition.scheme));
            const concepts = (schemes.length>0)?subsetByLangOrEmpty(schemes[0].concepts, lang, "IRI", "Label"):[];
            const labels = concepts.filter(concept => concept.IRI.value == scheme[0].value);
            scheme[0].label = (labels.length>0)?labels[0].Label.value:scheme[0].value;
        }
        return conditions;
    }
  }
  return conditions.filter(item => !((item.predicate==condition.predicate)&&(item.operator==condition.operator)&&(item.value==condition.value)));
}
/** Компонента для получения и отображения списка активов. 
 *  Доступные активы фиксируются в vadms.
 * Линковка props и vadms происходит в containers.js
 */
class AssetList extends React.Component {

    state = {
      modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог добавление нового элемениа
      authorized: undefined, //Состояние проверки авторизации WebProtege
    };

    componentDidMount() {
      //console.log("AssetList.js componentDidMount()", this.state);
      if (this.state.authorized == undefined){
        WebProtegeApi.checkAuthorization()
          .then(response => {
            //console.log("AssetList.js componentDidMount() ok", response);
            this.setState({authorized: true});
          })
          .catch(e => {
            //console.log("AssetList.js componentDidMount() error", e);
            this.setState({authorized: false});
          });
      }
    };

    formRef = React.createRef();
  
    //Событие об изменение состава условий отбора
    // include - true - добавить условие, false - удалить условие.
    // condition - само условие. 
    // Если условия из одной схемы, то создать массив, который будет объединятся по ИЛИ
    onChangeListConditions (include, condition) {
        //console.log("AssetList.js",this, include, condition);
        const {conditions, actions, taxonomy, lang, onChangeConditions} = this.props;
        let filter = conditions;
        if (Array.isArray(condition)){
          condition.forEach(item => 
            filter = (include)
              ? includedConditions(filter, item) 
              : excludedConditions(filter, item, taxonomy, lang)
          );
        } else {
          filter = (include)
            ? includedConditions(conditions, condition) 
            : excludedConditions(conditions, condition, taxonomy, lang);
        }
        if (onChangeConditions) onChangeConditions(AdmsRepository, filter);
    }

    onSearchByAlphabet(include, char){
      const {onAlphabetSearch, conditions} = this.props;
      if (onAlphabetSearch) onAlphabetSearch(AdmsRepository, (include)?char:"", conditions);      
    }

    onSearchByName (pattern) {
      //console.log("onSearchByName (pattern)", pattern, this);
      const {onNameSearch, conditions} = this.props;
      if (onNameSearch) onNameSearch(AdmsRepository, pattern, conditions);
    }

    onRefresh (e) {
      e.preventDefault();
      const {conditions} = this.props;
      this.props.onRefreshList(AdmsRepository, conditions);
    };
    onNewAsset(e){
      e.preventDefault();
      this.setState({modal:"add"});
    };

    onLinkAssetDialog(e){
      e.preventDefault();
      this.setState({modal:"link"});
    };

    
    onShowCatalogInformation(e){
      e.preventDefault();
      this.setState({modal:"info"});
    }

    onImportDialog(e){
      e.preventDefault();
      this.setState({modal:"import"});
    }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    //console.log("AssetList.js handlers", triplet, operation, this);
    const {catalog} = this.props;
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement) 
      this.props.onDetailElement(AdmsAsset, catalog.iri, triplet)
      .then (result =>{
        //console.log("AssetList.js handlers 2", result);
        this.setState({detail: triplet});
    });
  };

  cancelOperation(){
    this.setState({modal:"none", detail: undefined});
  };

  /** Закрыть детальную информацию (возможно из карточки каталога) */
  cancelDetail(){
    this.setState({detail: undefined});
  };

    /** Вызывается при добавлении новой карточки. Данные см. NewElement.js */
    submitOperation() {
      //console.log(' AssetList.js submitOperation() ', this, this.formRef);
      const form  = this.formRef.current;
      form.validateFields((err, values) => {
        //console.log("AssetList.js submitOperation() Received values of form: ", values, err);
        if (err) return; //console.log("Received values of form: ", values);
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))? values.IRI : "http://www.w3.org/ns/dcat#"+values.IRI;
        return; //TODO поравить форму
        //Проверим, что IRI отсутствует
        RdfTriplet.countSubject(IRI)
          .then ( response =>{
            const count = getCountValue(response.bindings);
            if (count>0){
              message.error(`IRI ${IRI} уже существует. Задайте другой идентификатор.`);
              return;
            }
            //Добавление всегда идёт в каталог, который доступен для зарегистрированных пользователей
            const catalog = settings.catalog.graph.signed;
            this.props.onAddElement(AdmsRepository, catalog, IRI, values.type, values.label.text, values.label.lang)
              .then (response =>{ 
                //const time = showMessageSuccess(store, "Добавление записи завершено успешно.");
                message.success("Добавление записи завершено успешно.");
                this.setState({modal:"none"}); 
              })
              .catch(e => {  message.error(`Ошибка при добавлении элемента в каталог. ${e}`); });                  
          })
          .catch(e => {  message.error(`Не удалось определить уникальность IRI. ${e}`); });
      });
    };
    
    /** Вызывается при вызове редактирования информации о каталоге */
    editCatalogOperation(e) {
      //Добавление всегда идёт в каталог, который доступен для зарегистрированных пользователей
      const graph = settings.catalog.graph.signed;
      const catalog = this.props.catalog.iri;
      const url = WebProtegeApi.getWebProtegeUrl()+'/webprotege/mpo?operation=create&graph='+graph+'&uri='+catalog+'&form='+new Date().getTime();
      //console.log("AssetList.js editCatalogOperation", graph, catalog, url);
      window.open(url);
    }  

  check(){

  }

  //Запускается при изменении IRI каталога
  onChangeCatalog(iri, graph){
    this.props.onEmpty(AdmsRepository, iri, graph);
  };

  onIncludeInCatalog(iri, graph){
    const { onIncludeInCatalog, conditions} = this.props;    
    confirm({ 
      title: i18n.t('views.adms.establishing_link_title'), 
      content: i18n.t('views.adms.establishing_link_content', {iri}),
      okText: i18n.t('views.adms.establishing_link_ok'), 
      okType: 'danger', 
      cancelText: i18n.t('views.adms.establishing_link_cancel'),
      onOk() { 
        onIncludeInCatalog(AdmsRepository, iri, graph, conditions)
        .then(respone => {
          message.success(i18n.t('views.adms.establishing_link_success'));
        })
        .catch(e=>{
          message.error(i18n.t('views.adms.establishing_link_error',{e})); 
        });
      },
      onCancel() {},
    });
  };

  onExcludeFromCatalog(iri, graph){
    const { onExcludeFromCatalog, onEmpty, conditions} = this.props;
    confirm({ 
      title: i18n.t('views.adms.break_link_title'), 
      content: i18n.t('views.adms.break_link_content', {iri}),
      okText: i18n.t('views.adms.break_link_ok'), 
      okType: 'danger', 
      cancelText: i18n.t('views.adms.break_link_cancel'),
      onOk() { 
        onExcludeFromCatalog(AdmsRepository, iri, graph, conditions)
        .then(respone => {
          message.success(i18n.t('views.adms.break_link_success'));
          onEmpty(AdmsRepository, iri, graph);
        })
        .catch(e=>{
          message.error(i18n.t('views.adms.break_link_error',{e})); 
        });
      },
      onCancel() {},
    });
};

  /** Вызывается при вызове редактирования информации о каталоге */
  submitLinkAssetOperation() {
    //console.log(' AssetList.js submitLinkAssetOperation() ', this, this.formRef);
    const form  = this.formRef.current;
    const { links, catalog, onLinkAsset } = this.props;
    form.validateFields()
      .then(values => {
        onLinkAsset(AdmsRepository, catalog.iri, values["IRI"])
        .then(response => {
          message.success(i18n.t('views.adms.establishing_link_success'));
          this.setState({modal:"none"}); 
        }).catch(e => {  
            message.error(i18n.t('views.adms.establishing_link_error',{e})); 
        });        
      });
  };
  
  render() {
        console.log(this);
        const { modal, authorized, detail } = this.state;
        const {taxonomy, conditions, isSignedIn, inGroup, factory, lang, catalog, vselected} = this.props;
        //Условия отбора задаются в vadms см. AdmsActions с использованием действий добавления/удаления условия 
        const isCondition = (conditions && Array.isArray(conditions))?conditions.length>0: false;
        const webProtegeAuthorized = authorized ? true : false;
        const catalogTitle = (catalog && Array.isArray(catalog.values))
          ? getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, catalog.values)
          : document.title; 

        return (
            <div>
                <Row>
                    <Col className="csi_search_bar_title" span={6} style={{}}></Col>
                    <Col className="csi_search_form_div" span={18} style={{}}><Search onSearch={(value) => this.onSearchByName(value)} /></Col>
                </Row>
                <Row>
                    <Col className="csi_filters" span={6} style={{}}>
                        {isCondition && (<Row style={{}} className="filterBrowserDiv"> <FilterData onChange={(i,c)=> this.onChangeListConditions(i,c)}/></Row>)}
                        <Row style={{}}> <Taxonomy selected={conditions} taxonomy={taxonomy} onChange={(i,c)=> this.onChangeListConditions(i,c)}/></Row>
                        <Row style={{display: "none"}}> <Tags/></Row>
                    </Col>
                    <Col className="csi_asset_list" span={18} style={{}}>
                        <Row><Alphabet selected={conditions} onChange={(i,c)=> this.onSearchByAlphabet(i,c)} /></Row>                            
                        <Row style={{display: "none"}}>
                          <Col style={{display: "none"}} span={24}>{i18n.t('views.adms.catalog_lang')}  <Langs /></Col>
                        </Row>
                        <Row>
                          <Col span={21}>
                            <Tooltip placement="top" title={i18n.t('views.adms.list_reload_title')}>
                                <Button icon={<CloudSyncOutlined />} onClick={(e)=> this.onRefresh(e)}></Button>
                              </Tooltip>
                          </Col>
                            <Col span={3} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                              {isSignedIn && !inGroup.Demo && (
                                <Tooltip placement="top" title={i18n.t('views.adms.settings_taxonomy')}>
                                  &nbsp;&nbsp;
                                  <SettingsMenu 
                                    router={this.props.router} 
                                    onChange={(iri, graph) => this.onChangeCatalog(iri, graph)}
                                    hasCondition={Array.isArray(this.props.conditions) && this.props.conditions.length>0}
                                    onInclude={(iri, graph) => this.onIncludeInCatalog(iri, graph)}
                                    onExclude={(iri, graph) => this.onExcludeFromCatalog(iri, graph)}
                                    inGroup={inGroup}
                                  />
                                </Tooltip>
                              )}
                              <Tooltip placement="top" title={i18n.t('views.adms.catalog_information_title')}>
                                &nbsp;&nbsp;
                                <Button icon={<InfoCircleOutlined />} onClick={(e)=> this.onShowCatalogInformation(e)}></Button>
                              </Tooltip>
                              { !inGroup.Demo && (
                                <Tooltip placement="top" title={i18n.t('views.adms.export_title')}>
                                  &nbsp;&nbsp;
                                  <ExportToDocument element="AssetRepository" title={catalogTitle} />
                                </Tooltip>
                              )}
                              {isSignedIn && inGroup.Operator && (
                                <>
                                  <Tooltip placement="top" title={i18n.t('views.adms.link_asset')}>
                                    &nbsp;&nbsp;
                                    <Button icon={<LinkOutlined />} onClick={(e)=> {this.onLinkAssetDialog(e)}} ></Button>
                                  </Tooltip>
                                  {/* <Tooltip placement="top" title={i18n.t('views.adms.list_add_title')}>
                                    &nbsp;&nbsp;
                                    <Button icon={<FileAddOutlined />} onClick={(e)=> this.onNewAsset(e)}></Button>
                                  </Tooltip> */}
                                </>
                              )}
                              {!inGroup.Demo && (
                                <Tooltip placement="top" title={i18n.t('views.adms.import_card_asset')}>
                                  &nbsp;&nbsp;
                                  <Button icon={<ImportOutlined />} onClick={(e)=> {(this.onImportDialog(e))}} ></Button> 
                                </Tooltip>
                              )}
                          </Col>
                        </Row>
                        <Row id="AssetRepository" ><Col span={24}><AssetRepository {...this.props} /></Col></Row>
                    </Col>
                </Row>
                {(modal=="add" )&& showAdd( this.formRef, ()=>this.submitOperation(), ()=>this.cancelOperation())}
                {(modal=="info" )&& showInfo( 
                  this.formRef, factory, ()=>this.editCatalogOperation(), ()=>this.cancelOperation(), 
                  webProtegeAuthorized, (e,t,o)=> this.handlers(e,t,o)
                  )}
                {detail && showViewDetail(this.modalFormRef, detail, factory, ()=>this.cancelDetail(), ()=>this.cancelDetail())}
                {(modal=="link" )&& showLinkAsset( 
                  this.formRef, factory, ()=>this.submitLinkAssetOperation(), ()=>this.cancelOperation(), 
                   (e,t,o)=> this.handlers(e,t,o),
                   catalog.iri, vselected && vselected.value
                )}
                { modal=="import" && <ImportCard open={true} onClose={()=> this.cancelOperation()} />}
            </div>            
        )
    }
}

export default AssetList;